module.exports = __webpack_public_path__ + "img/back_tit.45e5c275.png";